import React, { useState, useEffect, useRef } from 'react';

import { Container } from '@material-ui/core';

import { useLocation } from 'react-router-dom';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const PaysprintRedirectURL = () => {
    const formRef = useRef(null);

    const location = useLocation();

    const Hash = location.state.Hash;
    const RedirectURL = location.state.RedirectURL;
    const initialValues = {
        EncData: Hash,
        RedirectURL: RedirectURL
    };

    const [FormObj, setFormObj] = useState(initialValues);

    useEffect(() => {
        setFormObj({
            EncData: Hash,
            RedirectURL: RedirectURL
        });
        formRef.current.submit();
    }, []);
    return (
        <CustomContainer>
            <form
                ref={formRef}
                id="form1"
                method="post"
                name="form1"
                action={FormObj.RedirectURL}
            >
                <input name="encdata" type="hidden">
                    {FormObj.EncData}
                </input>
                <input type="submit" value="Submit" />
            </form>
        </CustomContainer>
    );
};
